import { redirectTo } from 'helpers/path'; // polyfill webpack require.ensure

if (typeof require.ensure !== 'function') require.ensure = function (deps, cbFn) {
  return cbFn(require);
};
export var FitnessTrendsRoute = function FitnessTrendsRoute() {
  return {
    path: '/fitness-trends',
    getIndexRoute: function getIndexRoute(location, callback) {
      require.ensure([], function () {
        callback(null, {
          onEnter: redirectTo('/fitness-trends/community/2018')
        });
      }, 'FitnessTrends');
    },
    getChildRoutes: function getChildRoutes(location, callback) {
      require.ensure([], function (require) {
        callback(null, [{
          path: 'community/:year',
          component: require('features/FitnessTrends/Community/FitnessTrendsCommunityContainer').FitnessTrendsCommunityContainer
        }, {
          path: 'members/:memberHash/:year',
          component: require('features/FitnessTrends/Member/FitnessTrendsMemberContainer').FitnessTrendsMemberContainer
        }]);
      }, 'FitnessTrends');
    }
  };
};